/**
 * Utilitaires SSO cross-app : validation returnTo et redirection post-login.
 */

const getDefaultOrigins = () =>
  [
    process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_APP_URL,
    process.env.REACT_APP_SHOP_URL,
  ].filter(Boolean);

export const getAllowedOrigins = () => {
  const extra = (process.env.REACT_APP_ALLOWED_RETURN_ORIGINS || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

  return [...new Set([...getDefaultOrigins(), ...extra])];
};

export const isAllowedReturnUrl = (url) => {
  try {
    const parsed = new URL(url);
    return getAllowedOrigins().some((origin) => {
      const allowed = new URL(origin);
      return parsed.origin === allowed.origin;
    });
  } catch {
    return false;
  }
};

export const getReturnToFromSearch = (search = window.location.search) => {
  const returnTo = new URLSearchParams(search).get('returnTo');
  if (!returnTo || !isAllowedReturnUrl(returnTo)) {
    return null;
  }
  return returnTo;
};

export const redirectToLogin = (returnTo = window.location.href) => {
  localStorage.removeItem('user');
  const appUrl = process.env.REACT_APP_PUBLIC_URL || process.env.REACT_APP_APP_URL || 'http://app.local.dev:8080';
  const safeReturnTo = isAllowedReturnUrl(returnTo) ? returnTo : window.location.href;
  window.location.replace(`${appUrl}/login?returnTo=${encodeURIComponent(safeReturnTo)}`);
};
